import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Interceptor that only intercepts requests to our backend (as opposed to extenal APIs such as giphy)
 */
@Injectable()
export abstract class AbstractAlcmeonBackendInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith(environment.apiURLPrefix)) {
      return this.doIntercept(request, next);
    } else {
      // Don't add header if we call external APIs such as gify
      return next.handle(request);
    }
  }

  protected abstract doIntercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>;
}
